export default __webpack_public_path__ + "573654d02e0deca3126d0befcf04b889.svg";